export type UploadedPatientType = {
  firstName: string
  lastName: string
  email: string
  ssin: string
  idCardNumber: string
  dateOfBirth: string | null
  birthSex: string // M || F
  statusTags: string
  streetAddress: string
  postalAddress: string
}

export enum UploadedPatientsTableTitlesEnum {
  FIRST_NAME = 'First name',
  LAST_NAME = 'Last name',
  SSIN = 'SSIN',
  ID_CARD_NUMBER = 'ID card number',
  EMAIL = 'E-mail',
  DATE_OF_BIRTH = 'Date of birth',
  BIRTH_SEX = 'Birth sex',
  STATUS_TAGS = 'Status tags',
  STREET_ADDRESS = 'Address: Street, number',
  POSTAL_ADDRESS = 'Address: Postal code, city',
}

export enum UploadedPatientsTableKeysEnum {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  SSIN = 'ssin',
  ID_CARD_NUMBER = 'idCardNumber',
  EMAIL = 'email',
  DATE_OF_BIRTH = 'dateOfBirth',
  BIRTH_SEX = 'birthSex',
  STATUS_TAGS = 'statusTags',
  STREET_ADDRESS = 'streetAddress',
  POSTAL_ADDRESS = 'postalAddress',
}
